import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Usuario, TipoUsuario, PuestoUsuario } from '../../../interfaces/usuario';
import { UsuarioService } from '../../../providers/usuario.service';
import { AuthenticationService } from '../../../providers/auth.service';
import { MatDialog } from '@angular/material';
import { AutorizadorDialog } from '../../../components/autorizador/autorizador.component';
import { Telefono } from '../../../components/telefono/telefono.component';
import { EstadoPropuesta } from '../../../interfaces/propuesta';
import { PropuestasService } from '../../../providers/propuestas.service';



@Component({
  selector: 'app-estado-propuesta',
  templateUrl: './estado-propuesta.component.html',
  styleUrls: ['./estado-propuesta.component.scss']
})
export class EstadoPropuestaComponent implements OnInit {
  @Input() idEstado?: number | string;
  estado_propuesta: EstadoPropuesta;


  cargandoPuestos: boolean = false;

  hide: boolean;
  @Output() onUsuarioInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario

  descFormControl = new FormControl('', [
    Validators.required
  ]);

  constructor(
    private usuariosService: UsuarioService,
    private propuestaService: PropuestasService,
    public dialog: MatDialog,
    public authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {


    if (this.idEstado != null) {
      // Inhabilitar campos no editables
      // this.usuarioFormControl.disable();

      this.propuestaService.getEstadoPropuesta(this.idEstado).subscribe(
        respuesta => {
          if (respuesta.estado == 1 && respuesta.estado_propuesta) {
            let estado_propuesta = respuesta.estado_propuesta;
            this.estado_propuesta = new EstadoPropuesta(
              estado_propuesta.id,
              estado_propuesta.descripcion,
              estado_propuesta.orden
            );

          }
        }
      );


    }else{
      this.estado_propuesta = new EstadoPropuesta();
    }

  }

 
  onInput(): void { // cuando cambia un dato del formulario emitimos un evento
    this.onUsuarioInput.emit();
  }



  compararTipoUsuario(dato1: TipoUsuario, dato2: TipoUsuario): boolean {
    if (dato1 && dato2) {
      return dato1.id == dato2.id;
    }

    return false;
  }

  compararPuesto(puesto1: PuestoUsuario, puesto2: PuestoUsuario): boolean {
    if (puesto1 && puesto2) {
      return puesto1.id == puesto2.id;
    }

    return false;
  }

  getEstado(): EstadoPropuesta {
    return this.estado_propuesta;
  }

}
